module.exports = __webpack_public_path__ + "static/media/Seedot_gaussian2.4dc24f3e.png";